import React from 'react'

const Hr = () => {
    return (
        <>
            <hr className='hr' />
        </>
    )
}

export default Hr